// @martyrs/src/modules/auth/locales/en.js
export default {
  auth: {
    popup: {
      title: "Welcome",
      subtitle: "Please sign in or create an account to continue.",
      signUp: "Sign Up",
      haveAccount: "Already have an account?",
      signIn: "Sign in"
    },
    signIn: {
      title: "Welcome to OZ DAO,",
      subtitle: "Sign In to Continue",
      signup: "Don't have an account?",
      phone: "Phone",
      email: "Email",
      phonePlaceholder: "Enter your phone",
      emailPlaceholder: "Enter your email",
      haveAccount: "Don't have an account? Sign Up",
      passwordPlaceholder: "Enter your password",
      forgotPassword: "Forgot Password?",
      signin: "Sign In",
      signin_apple: "Sign In with Apple",
      soon: "SOON"
    },
    signUp: {
      title: "Sign Up",
      description: "Choose a convenient way to register via phone or email:",
      phone: "Phone",
      email: "Email",
      phonePlaceholder: "Enter your phone",
      emailPlaceholder: "Enter your email",
      emailNotice: "We will send you an email with a confirmation code that you will need to enter in the next step.",
      smsNotice: "We will send you an SMS with a confirmation code that you will need to enter in the next step.",
      sendCode: "Send Code",
      haveAccount: "Already have an account?",
      agreement: "By registering, you agree to our <a href='/legal/eula' target='_blank'>End User License Agreement (EULA)</a>"
    },
    enterCode: {
      verifyNumberTitle: "Verify Number",
      verifyEmailTitle: "Verify Email",
      instructions: "We have sent a registration code to your phone number. Please enter it in the field below:",
      instructionsEmail: "We have sent a registration code to your email. Please enter it in the field below:",
      verifyChangeTitle: "Verify Change",
      current: "Current",
      new: "New",
      confirm: "Confirm",
      resendCode: "Send the code again",
      secondsResend: "seconds to the possibility of sending the code again."
    },
    resetPassword: {
      forgotPasswordTitle: "Forgot Password?",
      instructions: "To reset your password, specify the phone or email used during registration.",
      smsInfo: "We will send you an SMS with a confirmation code to reset your password, which you will need to enter in the next step.",
      emailInfo: "We will send you an email with a confirmation code to reset your password, which you will need to enter in the next step.",
      phone: "Phone",
      email: "Email",
      phonePlaceholder: "Enter your phone",
      emailPlaceholder: "Enter your email",
      sendCode: "Send code"
    },
    enterPassword: {
      almostDone: "Almost there!",
      newPasswordPrompt: "Please, set a new password.",
      registrationPasswordPrompt: "Please, set your password to complete the registration.",
      passwordPlaceholder: "Password",
      repeatPasswordPlaceholder: "Repeat Password",
      changePasswordBtn: "Change Password",
      registerBtn: "Register"
    },
    features: [
      {
        title: "Everything in one place",
        description: "Manage your account, data and settings from a single interface."
      },
      {
        title: "Secure by default",
        description: "Code-based sign-in and safe data storage keep your account protected."
      },
      {
        title: "Quick start",
        description: "Sign up in a minute and get to work right away."
      },
      {
        title: "Support at hand",
        description: "Need help? We're here and ready to answer your questions."
      }
    ]
  }
};